var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWltLogoSmallPl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.551,
    height: 15.176,
    viewBox: "0 0 45.551 15.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ddd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.204 -7.14)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M98.374,28.47l-1.4-5.606h-.023L95.582,28.47H93.748l-2.18-8.236h1.811l1.3,5.606h.023l1.43-5.606h1.7l1.408,5.675h.023l1.35-5.675h1.777l-2.215,8.236Z",
    transform: "translate(-58.883 -9.715)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M141.808,20.234v6.714h4.014V28.47H140V20.234Z",
    transform: "translate(-94.815 -9.715)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M162.571,21.757V20.234h6.748v1.522H166.85V28.47H165.04V21.757Z",
    transform: "translate(-111.564 -9.715)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.022,11.618H12.2V7.14h4.737V8.958H14.022Zm0,6.219H12.2v4.478h4.737V20.5H14.022Zm11.54-5.961H27.38V7.14H22.643V8.958h2.919Zm0,8.621H22.643v1.818H27.38V17.579H25.562Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.993,25.519H30v1.957h2.016v3.991h1.957V27.476h2.016Z",
    transform: "translate(-13.206 -13.636)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWltLogoSmallPl);
export default __webpack_public_path__ + "static/media/wlt_logo_small_pl.c234fc07fa5a9052f7a6ee405b4ab20e.svg";
export { ForwardRef as ReactComponent };